import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const CallOpen = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M12.8134 10.1667L11.1334 9.97332C10.7267 9.92665 10.3267 10.0667 10.04 10.3533L8.80669 11.5867C7.86069 11.1067 7.00269 10.4807 6.26136 9.73865C5.51936 8.99732 4.89336 8.13932 4.41336 7.19332L5.64669 5.95999C5.93336 5.67332 6.07336 5.27332 6.02669 4.86665L5.83336 3.18665C5.75336 2.51332 5.18669 2.00665 4.50669 2.00665H3.35336C2.60003 2.00665 1.97336 2.63332 2.02003 3.38665C2.19669 6.23265 3.42269 8.79199 5.31536 10.6847C7.20803 12.5773 9.76736 13.8033 12.6134 13.98C13.3667 14.0267 13.9934 13.4 13.9934 12.6467V11.4933C13.9934 10.8133 13.4867 10.2467 12.8134 10.1667Z",
      fill: "currentColor"
    }
  ) }),
  "CallOpen"
);
export {
  CallOpen
};
